import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../../Configuration/configuration.service';
import { LocalStorageService } from '../../../../Shared/common/local-storage.service';
import { CharityDataShareServiceService } from '../../charities/services/charity-data-share-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuditorsReportService {

  constructor(private http: HttpClient, private configService: ConfigurationService, private dataShareService: CharityDataShareServiceService, private lsService: LocalStorageService) { }
  private apiUrl = this.configService.getAPIBaseUrl();

  SaveAuditorsReport(AuditForm: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/AuditorsReport/SaveAuditorsReport`;
    return this.http.post(url, AuditForm);
  }
  GetAuditorsReport(id: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/AuditorsReport/GetAuditorsReport?id=`;
    return this.http.get(url + id);
  }
}
